'use client';

import { type UserAccount } from '@ocode/domain';
import { BrowserStorageWrapper, SingleValueRxEmitter } from '@ocodelib/ex-util';
import { AESEncoder } from '@repo-foundation/crypto/AESEncoder';
import { safeGetLocalStorage } from '@repo-foundation/util/DummyStorage';
import { config } from '../config/index';

const AUTH_REFRESH_TOKEN_STORAGE_KEY = config.storageKeys.authRefreshToken;
const AUTH_TOKEN_STORAGE_KEY = config.storageKeys.authToken;
const AUTH_PROFILE_STORAGE_KEY = config.storageKeys.profile;
const AI_TOKEN_STORAGE_KEY = config.storageKeys.aiToken;
const BROWSER_ID_STORAGE_KEY = config.storageKeys.browserId;

const secret = '836D96123430DD58429D2751AC1BDBBC';
const aes = new AESEncoder(secret);

const serialize = <T>(value: T): string => {
  return aes.enc(JSON.stringify(value));
};

const deserialize = <T>(value: string): T => {
  return JSON.parse(aes.dec(value)) as T;
};

// const serializeDebug = <T>(value: T): string => {
//   console.log("serialize", value, "result=", JSON.stringify(value));
//   return JSON.stringify(value);
// };

// const deserializeDebug = <T>(value: string): T => {
//   // console.log("deserialize", value, "result=", JSON.parse(value));
//   return JSON.parse(value);
// };

/**
 * 브라우저 ID 스토리지
 */
export const BrowserIdStorage = new BrowserStorageWrapper<string>({
  storage: safeGetLocalStorage,
  storageKey: BROWSER_ID_STORAGE_KEY,
  serialize,
  deserialize,
});

// BrowserIdStorage.debug = BROWSER_ID_STORAGE_KEY;

/**
 * 사용자 프로필 정보 스토리지
 */
export const LoginProfileStorage = new BrowserStorageWrapper<UserAccount>({
  storage: safeGetLocalStorage,
  storageKey: AUTH_PROFILE_STORAGE_KEY,
  serialize,
  deserialize,
});
// LoginProfileStorage.debug = AUTH_PROFILE_STORAGE_KEY;

/**
 * 인증 토큰 저장소
 */
export const LoginTokenStorage = new BrowserStorageWrapper<string>({
  storage: safeGetLocalStorage,
  storageKey: AUTH_TOKEN_STORAGE_KEY,
  serialize,
  deserialize,
});
// LoginTokenStorage.debug = AUTH_TOKEN_STORAGE_KEY;

/**
 * AI 토큰 저장소
 */
export const AiTokenStorage = new BrowserStorageWrapper<string>({
  storage: safeGetLocalStorage,
  storageKey: AI_TOKEN_STORAGE_KEY,
  serialize,
  deserialize,
});

/**
 * 리프레시 토큰 저장소
 */
export const LoginRefreshTokenStorage = new BrowserStorageWrapper<string>({
  storage: safeGetLocalStorage,
  storageKey: AUTH_REFRESH_TOKEN_STORAGE_KEY,
  serialize,
  deserialize,
});

/**
 * 프로필 정보를 로드했다는 이벤트
 */
export const LoginProfileLoadedEvent = new SingleValueRxEmitter<UserAccount>();
